<template>
  <div class="action-menu">
    <el-dropdown class="utilsMenu" size="medium" trigger="click" @command="handleCommand">
      <el-button icon="el-icon-more-outline" circle></el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="removeActiveElement"><i class="fas fa-trash-alt"></i> Usuń element</el-dropdown-item>
        <el-dropdown-item command="addText"><i class="fas fa-pencil-alt"></i> Dodaj tekst</el-dropdown-item>
        <el-dropdown-item command="save"><i class="far fa-save"></i> Zapisz</el-dropdown-item>
        <el-dropdown-item command="undo"><i class="fas fa-undo"></i> Cofnij</el-dropdown-item>
        <el-dropdown-item command="redo"><i class="fas fa-redo"></i> Ponów</el-dropdown-item>
        <el-dropdown-item command="showHelpModal"><i class="fas fa-question"></i> Pomoc</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    methods: {
      handleCommand(command) {
        console.log('command', command)
        // this[command]();
      },
    }
  }
</script>

<style lang="less" scoped>
  .utilsMenu {
    position: fixed;
    bottom: 95px;
    right: 20px;
    z-index: 1;
    border-radius: 50%;
    background: #fff;
    height: 40px;
    width: 40px;
    line-height: 30px;
    display: block;
    padding: 0;
    box-shadow: 0 5px 5px #ccc;

    @media (min-width: 1024px) {
      display: none;
    }

    i {
      color: #222;
    }
  }
</style>